/**
 * Gets the unique trade-title pairs from a list of items that mimic the
 * jobsite worker structure.
 * @param items - The list of items to process.
 * @param selector - A function that extracts the trade and title from each item.
 */
export function getTradeTitlePairs<T>(
  items: readonly T[],
  selector: (item: T) => [string | null | undefined, string | null | undefined],
): string {
  const pairs = new Set<string>();

  items.forEach((item) => {
    const [trade, title] = selector(item);
    const pair = [trade, title].filter(Boolean).join(', ');
    if (pair) pairs.add(pair);
  });

  return [...pairs].join('; ');
}

type JobsiteWorkerTradeTitleEdge = {
  node?: { trade?: string | null; jobTitle?: string | null };
};

/**
 * Extracts unique trade-title pairs from Jobsite Worker edge nodes, which are
 * commonly included in the graph under workers.
 */
export function getTradeTitlePairsFromJobsiteWorkerEdges<
  E extends JobsiteWorkerTradeTitleEdge,
>(edges: readonly E[]): string {
  return getTradeTitlePairs(edges, ({ node }) => [node?.trade, node?.jobTitle]);
}
